import { useNavigate, useParams } from 'react-router-dom';
import Conversations from '@/components/Conversations';

export function ConversationsPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();

  return <Conversations onBack={() => navigate('/dashboard')} initialConversationId={id || null} />;
}
